import { Component, Inject, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { CampaignType } from 'spotlight-ui/app/models/engage/campaign-details.model';

@Component({
  templateUrl: './campaign-confirmation-dialog.component.html',
  styleUrls: ['./campaign-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class CampaignConfirmationDialogComponent implements OnInit {
  public startDate: moment.Moment;
  public endDate: moment.Moment;
  public count: number;
  public rewardLength: number;
  public groupNow: boolean;
  public campaignType: any;
  public confirmationText: string;
  public fromDiscover: boolean;
  protected readonly CampaignType = CampaignType;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) private readonly dialogData: any,
              public dialogRef: MatDialogRef<CampaignConfirmationDialogComponent>) {
  }

  public ngOnInit() {
    this.startDate = this.dialogData.startDate;
    this.endDate = this.dialogData.endDate;
    this.rewardLength = this.endDate.diff(this.startDate, 'days');
    this.rewardLength = this.rewardLength === 0 ? 1 : this.rewardLength;
    this.count = this.dialogData.count;
    this.campaignType = this.dialogData.campaignType;
    this.fromDiscover = this.dialogData.fromDiscover;
    this.groupNow = this.dialogData.groupNow;
    this.confirmationText = this.dialogData.confirmationText;
  }

  public closeDialog(shouldSend: boolean) {
    this.dialogRef.close(shouldSend);
  }

  public sendDisabled(count: number, campaignType: CampaignType) {
    return (count === 0) && campaignType != CampaignType.Automation;
  }
}
